<template>
  <div class="edu-contact-area ptb-100">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-12 col-md-12">
          <div class="card" v-if="isLoading">
            <LoadingPage />
          </div>
          <div class="contact-form" v-if="!isLoading">
            <form id="contactForm" @submit.prevent="submitForm">
              <div class="row">
                <h1 class="mb-4 text-center font-bold text-lg">Form Register Training</h1>
                <div class="card">
                  <div class="card-header">1. General Form</div>
                  <div class="card-body pt-5">
                    <div class="row">
                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Fullname</h5>
                          <span class="text-danger info-form ms-2"
                            >*Based on your ID for certificate purpose</span
                          >
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            name="name"
                            v-model="fullname"
                            class="form-control"
                            id="name"
                            required
                            placeholder="Fullname"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Email</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <input
                            type="email"
                            name="email"
                            v-model="email"
                            class="form-control"
                            id="email"
                            required
                            placeholder="Email"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Phone Code</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <VueMultiselect
                            v-model="phoneCode"
                            :options="listCountry"
                            :close-on-select="true"
                            @close="selectPhoneCode"
                            :show-labels="false"
                            placeholder="Choose Phone Code"
                            label="phone_name"
                            track-by="phone_name"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Phone Number</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            name="phone"
                            v-model="phone"
                            class="form-control"
                            id="phone_number"
                            required
                            placeholder="Phone Number"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-lg-4 col-md-4">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Nationality</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <VueMultiselect
                            v-model="selectNationality"
                            :options="listNationality"
                            :close-on-select="true"
                            :show-labels="false"
                            @close="handleSelectNationality"
                            placeholder="Choose Nationality"
                            label="name"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-lg-4 col-md-4">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Birthplace</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            name="birthplace"
                            v-model="birthplace"
                            class="form-control"
                            id="birthplace"
                            required
                            placeholder="Birthplace"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-lg-4 col-md-4">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Birthdate</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <input
                            type="date"
                            name="birthdate"
                            v-model="birthdate"
                            class="form-control"
                            id="birthdate"
                            required
                            placeholder="Birthplace"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Address</h5>
                          <span class="text-danger info-form ms-2">*</span>
                        </div>
                        <div class="form-group">
                          <textarea
                            name="address"
                            v-model="address"
                            class="form-control"
                            id="address"
                            required
                            placeholder="Input your address"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card mt-5">
                  <div class="card-header">2. Education & Working Form</div>
                  <div class="card-body pt-5">
                    <div class="row">
                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Last Education</h5>
                        </div>
                        <div class="form-group">
                          <VueMultiselect
                            v-model="selectEducation"
                            :options="listEducation"
                            :close-on-select="true"
                            :show-labels="false"
                            @close="handleSelectEducation"
                            placeholder="Choose Education"
                            label="name"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Working Status</h5>
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            name="working_status"
                            v-model="working_status"
                            class="form-control"
                            id="working_status"
                            required
                            placeholder="Working Status"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Company Name</h5>
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            name="company_name"
                            v-model="company_name"
                            class="form-control"
                            id="company_name"
                            required
                            placeholder="Company Name"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 col-md-6">
                        <div class="d-flex align-items-center mb-2">
                          <h5 class="mb-0">Position</h5>
                          <span class="text-danger info-form ms-2"
                            >*Your position on working place</span
                          >
                        </div>
                        <div class="form-group">
                          <input
                            type="text"
                            name="position"
                            v-model="position"
                            class="form-control"
                            id="position"
                            required
                            placeholder="Input your position"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card mt-5 mb-5">
                  <div class="card-header">3. Identity Form</div>
                  <div class="card-body pt-5">
                    <div class="row">
                      <div class="col-12 col-lg-6 col-md-6">
                        <h5>Id Number</h5>
                        <div class="form-group">
                          <input
                            type="text"
                            name="id_number"
                            v-model="idNumber"
                            class="form-control"
                            id="id_number"
                            required
                            placeholder="ID Card Number"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 col-md-6">
                        <h5>Passport Number</h5>
                        <div class="form-group">
                          <input
                            type="text"
                            name="passport_number"
                            v-model="passport_number"
                            class="form-control"
                            id="passport_number"
                            required
                            placeholder="Passport Number"
                          />
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 col-md-6">
                        <h5>Upload ID Card Image</h5>
                        <div class="form-group row">
                          <div class="col-12 col-md-3 col-lg-3">
                            <upload-file
                              v-model="imageFile"
                              label="ID Card Image"
                              @imageSelected="handleImageIDCardSelected"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-6 col-md-6">
                        <h5>Upload Image Passport</h5>
                        <div class="form-group row">
                          <div class="col-12 col-md-3 col-lg-3">
                            <upload-file
                              v-model="imageFile"
                              label="Passport Image"
                              @imageSelected="handleImagePassportSelected"
                            />
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-lg-12 col-md-12">
                        <h5>Image Profile Upload</h5>
                        <div class="form-group row">
                          <div class="col-12 col-md-3 col-lg-3">
                            <upload-file
                              v-model="imageFile"
                              label="Photo Profile"
                              @imageSelected="handleImageSelected"
                            />
                          </div>
                          <div class="col-12 col-md-7 col-lg-7">
                            <ul style="list-style: disc">
                              <li>
                                Body position upright, straight forward, natural
                                expression *no visible teeth
                              </li>
                              <li>
                                Formal attire includes a collared shirt, tie, jacket; for
                                women formal clothing (*including those who wear the
                                hijab); Don't wear glasses and excessive accessories.
                              </li>
                              <li>Photo size 3x4</li>
                              <li>Blue Background</li>
                              <li>Recent photo of participant (*at least 1 year)</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12 col-md-6">
                  <h5>Course Selection</h5>
                  <div class="form-group">
                    <VueMultiselect
                      v-model="productBatch"
                      :options="listProduct"
                      :multiple="true"
                      :taggable="true"
                      :close-on-select="true"
                      @close="calculateCost"
                      @change="onTagChange"
                      placeholder="Choose Course You Want"
                      label="name"
                      track-by="name"
                    >
                      <template #option="{ option }">
                        <div class="custom-option">
                          <span>{{ option.name }} - </span>
                          <small class="option-description"
                            >({{
                              option?.currency_type?.code +
                              " - " +
                              option.price.toLocaleString()
                            }})</small
                          >
                        </div>
                      </template>
                    </VueMultiselect>
                  </div>
                </div>

                <div class="col-lg-12 col-md-6">
                  <h5>Payment Method</h5>
                  <div class="form-group">
                    <VueMultiselect
                      v-model="paymentMethod"
                      :options="listPaymentMethod"
                      :close-on-select="true"
                      placeholder="Choose Payment Method"
                      label="name"
                      track-by="name"
                    >
                    </VueMultiselect>
                  </div>
                </div>

                <div class="col-12 col-lg-6 col-md-6">
                  <h3 class="mb-3">Payment Summary</h3>
                  <div class="card card-payment-summary">
                    <div class="card-body pt-5 py-3 px-3">
                      <div class="row">
                        <div class="col-md-4">Subtotal</div>
                        <div class="col-md-4 text-end">USD {{ estimateCost }}</div>
                      </div>
                      <div class="row">
                        <div class="col-md-4">Taxes & Fees</div>
                        <div class="col-md-4 text-end">USD 0</div>
                      </div>
                      <div class="separator"></div>
                      <div class="row total">
                        <div class="col-md-4">Total</div>
                        <div class="col-md-4 text-end">USD {{ estimateCost }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-12 col-md-12 mt-5">
                  <button type="submit" class="btn btn-lg btn-primary">
                    <i class="bx bx-paper-plane"></i> Register Now
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style>
.card-header {
  font-size: 1.5rem;
  font-weight: 600;
  padding: 10px;
}
.multiselect__tag {
  background: #0d6efd;
}
.multiselect__tag-icon::after {
  color: #fff !important;
}
.multiselect__option--highlight {
  background: #0d6efd;
  color: #fff;
}
.multiselect__tags {
  min-height: 50px;
  font-size: 18px;
}
.separator {
  margin: 5px 0px;
  border-bottom: 1px solid #b0acac;
}
.card-payment-summary {
  border-radius: 15px !important;
}
.card-payment-summary .card-body pt-5 {
  background-color: #f5f5f5;
  border-radius: 15px !important;
}
.card-payment-summary .total {
  font-weight: 600;
  font-size: 22px;
}
</style>
<script>
import UploadFile from "./UploadFile";
import axios, { all } from "axios";
import { ref, watch } from "vue";
import VueMultiselect from "vue-multiselect";
import LoadingPage from "../Common/LoadingPage.vue";
import Swal from "sweetalert2";

export default {
  components: { UploadFile, VueMultiselect, LoadingPage },
  watch: {
    productBatch(newValue, oldValue) {
      if (Object.keys(this.productBatch).length == 0) {
        this.estimateCost = 0;
      }
      if (this.productBatch.length == undefined && this.productBatch.id != undefined) {
        this.estimateCost = 1500;
      }
      if (newValue.length < oldValue.length) {
        this.calculateCost();
      }
    },
  },
  setup() {
    const listPaymentMethod = ref([
      { value: "PAYPAL", name: "Paypal / Credit Card" },
      { value: "BANK_TRANSFER", name: "Bank Transfer" },
    ]);
    const paymentMethod = ref("");
    const modal = ref(true);
    const isLoading = ref(false);
    const fullname = ref("");
    const email = ref("");
    const phone = ref("");
    const idNumber = ref("");
    const imageFile = ref("");
    const imagePassportFile = ref("");
    const imageIDCardFile = ref("");
    const working_status = ref("");
    const address = ref("");
    const birthplace = ref("");
    const birthdate = ref("");
    const company_name = ref("");
    const position = ref("");
    const passport_number = ref("");
    const productBatch = ref([]);
    const estimateCost = ref(0);
    const phoneCode = ref("");
    const listCountry = ref([]);
    const listNationality = ref([
      { value: "WNI", name: "Warga Negara Indonesia (WNI)" },
      { value: "WNA", name: "Warga Negara Asing (WNA)" },
    ]);
    const selectNationality = ref("");
    const listEducation = ref([
      { value: "Sekolah Dasar (SD)", name: "Sekolah Dasar (SD)" },
      { value: "Sekolah Menengah Pertama (SMP)", name: "Sekolah Menengah Pertama (SMP)" },
      { value: "Sekolah Menengah Atas (SMA)", name: "Sekolah Menengah Atas (SMA)" },
      {
        value: "Sekolah Menengah Kejuruan (SMK)",
        name: "Sekolah Menengah Kejuruan (SMK)",
      },
      { value: "Diploma (D1/D2/D3/D4)", name: "Diploma (D1/D2/D3/D4)" },
      { value: "Sarjana (S1)", name: "Sarjana (S1)" },
      { value: "Magister (S2)", name: "Magister (S2)" },
      { value: "Doktor (S3)", name: "Doktor (S3)" },
      { value: "Bachelor of Arts (B.A.)", name: "Bachelor of Arts (B.A.)" },
      { value: "Bachelor of Science (B.Sc.)", name: "Bachelor of Science (B.Sc.)" },
      {
        value: "Bachelor of Applied Science (B.A.S.)",
        name: "Bachelor of Applied Science (B.A.S.)",
      },
      {
        value: "Bachelor of Engineering (B.Eng.)",
        name: "Bachelor of Engineering (B.Eng.)",
      },
      {
        value: "Bachelor of Business Administration (B.B.A.)",
        name: "Bachelor of Business Administration (B.B.A.)",
      },
      {
        value: "Bachelor of Computer Science (B.C.S)",
        name: "Bachelor of Computer Science (B.C.S)",
      },
      { value: "Bachelor of Education (B.E.)", name: "Bachelor of Education (B.E.)" },
      { value: "Bachelor of Nursing (B.N.)", name: "Bachelor of Nursing (B.N.)" },
      { value: "Bachelor of Medicine (B.M.)", name: "Bachelor of Medicine (B.M.)" },
      { value: "Bachelor of Laws (L.L.B.)", name: "Bachelor of Laws (L.L.B.)" },
      { value: "Master of Arts (M.A.) ", name: "Master of Arts (M.A.) " },
      { value: "Master of Science (M.Sc.)", name: "Master of Science (M.Sc.)" },
      {
        value: "Master of Business Administration (M.B.A.) ",
        name: "Master of Business Administration (M.B.A.) ",
      },
      {
        value: "Master of Engineering (M.Eng.) ",
        name: "Master of Engineering (M.Eng.) ",
      },
      { value: "Master of Laws (LL.M.) ", name: "Master of Laws (LL.M.) " },
      {
        value: "Master of Public Health (M.P.H.) ",
        name: "Master of Public Health (M.P.H.) ",
      },
      { value: "Master of Fine Arts (M.F.A.) ", name: "Master of Fine Arts (M.F.A.) " },
      { value: "Master of Research (MRes)", name: "Master of Research (MRes)" },
      { value: "Master of Studies (MSt) ", name: "Master of Studies (MSt) " },
      { value: "Master of Management (M.Mgt.)", name: "Master of Management (M.Mgt.)" },
      { value: "Other", name: "Other" },
    ]);
    const selectEducation = ref("");
    const apiBaseUrl = process.env.VUE_APP_API_BASE_URL;

    const showConfirmation = () => {
      Swal.fire({
        title: "All In Package",
        text:
          "We have All in Package so you can get all training course just for USD 1,500, Do you want to choose this package?",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Yes, choose it!",
        cancelButtonText: "No, cancel",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          choosePackage();
        }
      });
    };

    const choosePackage = () => {
      let product = listProduct.value.find((item) => item.id === 47);
      productBatch.value = product;
    };

    const calculateCost = () => {
      let tmpCost = 0;
      let allIn = false;
      productBatch.value.forEach((element) => {
        if (allIn == false) {
          if (element.id == 47) {
            tmpCost = element.price;
            allIn = true;
            productBatch.value = element;
          } else {
            tmpCost = tmpCost + element.price;
          }
        }
      });

      if (tmpCost > 1000 && allIn == false) {
        showConfirmation();
      }

      estimateCost.value = tmpCost.toLocaleString();
    };

    const listProduct = ref([]);

    const loadProduct = async () => {
      axios({
        method: "get",
        url: apiBaseUrl + "product/list/public?is_pagination=true&page=1&limit=10",
      })
        .then((response) => {
          listProduct.value = response.data.data;
        })
        .catch((error) => {
          console.log(error.message);
        });
    };

    const loadListCountry = async () => {
      axios({
        method: "get",
        url: apiBaseUrl + "region/country/search",
      })
        .then((response) => {
          listCountry.value = response.data.data;
        })
        .catch((error) => {
          console.log(error.message);
        });
    };

    loadProduct();
    loadListCountry();

    const handleImageSelected = (base64) => {
      imageFile.value = base64;
    };

    const handleImageIDCardSelected = (base64) => {
      imageIDCardFile.value = base64;
    };

    const handleImagePassportSelected = (base64) => {
      imagePassportFile.value = base64;
    };

    const selectPhoneCode = () => {
      console.log(phoneCode.value.phone_code);
    };

    const submitForm = async () => {
      isLoading.value = true;
      let tmpProductSelected = [];

      if (productBatch.value.length == 0) {
        Swal.fire({
          title: "Warning",
          text: "You Need To Select Course First",
          icon: "warning",
        });

        isLoading.value = false;

        return false;
      }

      if (paymentMethod.value.length == 0) {
        Swal.fire({
          title: "Warning",
          text: "You Need To Select Payment Method",
          icon: "warning",
        });

        isLoading.value = false;

        return false;
      }

      if (Array.isArray(productBatch.value)) {
        productBatch.value.forEach((element) => {
          tmpProductSelected.push(element.product_batch[0].id);
        });
      } else {
        tmpProductSelected.push(productBatch.value.product_batch[0].id);
      }

      axios({
        method: "post",
        url: apiBaseUrl + "member-custom/register",
        data: {
          fullname: fullname.value,
          email: email.value,
          phone_code: phoneCode.value.phone_code,
          phone: phone.value,
          id_card_number: idNumber.value,
          passport_number: passport_number.value,
          photo_file: imageFile.value,
          id_card_file: imageIDCardFile.value,
          passport_file: imagePassportFile.value,
          product_batch: tmpProductSelected,
          working_status: working_status.value,
          position: position.value,
          company_origin: company_name.value,
          last_education: selectEducation.value.value,
          detail_address: address.value,
          birthplace_name: birthplace.value,
          birth_date: birthdate.value,
          payment_method: paymentMethod.value.value,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.data.payment_method == "BANK_TRANSFER") {
            window.location.href = "/payment/manual/" + response.data.data.id;
          } else {
            window.location.href = "/payment?id=" + response.data.data.id;
          }
        })
        .catch((error) => {
          isLoading.value = false;
          Swal.fire({
            title: "Error",
            text: Array.isArray(error.response.data.message)
              ? error.response.data.message.join(", ")
              : error.response.data.message,
            icon: "warning",
          });
        });
    };

    return {
      fullname,
      email,
      phone,
      idNumber,
      imageFile,
      submitForm,
      handleImageSelected,
      listProduct,
      productBatch,
      calculateCost,
      estimateCost,
      phoneCode,
      listCountry,
      selectPhoneCode,
      listNationality,
      selectNationality,
      listEducation,
      selectEducation,
      handleImageIDCardSelected,
      handleImagePassportSelected,
      imagePassportFile,
      imageIDCardFile,
      working_status,
      address,
      birthplace,
      birthdate,
      company_name,
      position,
      passport_number,
      isLoading,
      modal,
      listPaymentMethod,
      paymentMethod,
    };
  },
};
</script>
